import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { useSelector } from 'react-redux';
import { DisplayListPagination } from '../../../components/TapUi';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';

const NotificationType = ({ history }) => {

    const [loading, setLoading] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);

    const access_token = useSelector(state => state.auth.access_token);
    const notificationUrl = BACKOFFICE_BASE_URL + '/notification_type';

    // ================= DELETE =================
    const deleteNotificationInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization(
                    'DELETE',
                    `${notificationUrl}/delete/${id}`,
                    access_token,
                    {},
                    {},
                    (response) => {
                        toast.success(response.data.msg, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        getNotificationListing(1);
                    }
                );
            }
        });
    };

    // ================= EDIT =================
    const editNotificationInit = (item) => {
        history.push({
            pathname: `/notification_type_add`,
            state: { editNotificationData: item }
        });
    };

    // ================= LIST API =================
    const getNotificationListing = (page = 1) => {
        setLoading(true);

        const params = {
            page: page,
            per_page: 15
        };

        HttpAPICall.withAthorization(
            "GET",
            `${notificationUrl}/list`,
            access_token,
            params,
            {},
            (response) => {
                const respData = response.data;

                setNotificationData(respData.data || []);

                setListingMeta({
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page
                });
            }
        ).then(() => setLoading(false));
    };

    useEffect(() => {
        getNotificationListing(1);
    }, []);

    // ================= TABLE =================
    const notificationListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr>
                            <th className='text-center' style={{ width: "10%" }}>S.No.</th>
                            <th className='text-center'>Notification Name</th>
                            <th className='text-center'>Event ID</th>
                            <th className='text-center' style={{ width: "10%" }}>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4}>
                                    <Loader />
                                </td>
                            </tr>
                        ) : notificationData.length > 0 ? (
                            notificationData.map((item, k) => {

                                const currentPage = listingMeta?.current_page || 1;
                                const perPage = listingMeta?.per_page || 15;
                                const serialNo =
                                    ((currentPage - 1) * perPage) + k + 1;

                                return (
                                    <tr key={item.id}>
                                        <td className='text-center'>{serialNo}</td>

                                        <td className='text-center text-capitalize'>
                                            {item.name}
                                        </td>

                                        <td className='text-center'>
                                            {item.type || '-'}
                                        </td>

                                        <td className='text-center'>
                                            <button
                                                type="button"
                                                className="btn btn-link"
                                                data-bs-toggle="dropdown"
                                            >
                                                <TapIcon.imageIcon
                                                    icon={TapIcon.ListActionIcon}
                                                    className="img-fluid"
                                                    alt="action-icon"
                                                />
                                            </button>

                                            <ul className="dropdown-menu">
                                                <li>
                                                    <button
                                                        className='dropdown-item'
                                                        onClick={() => editNotificationInit(item)}
                                                    >
                                                        Edit
                                                    </button>
                                                </li>

                                                <li>
                                                    <button
                                                        className='dropdown-item'
                                                        onClick={() => deleteNotificationInit(item.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No Records
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {listingMeta && listingMeta.total > 15 && (
                    <DisplayListPagination
                        meta={listingMeta}
                        onPageChange={(e) =>
                            getNotificationListing(e.selected + 1)
                        }
                    />
                )}
            </>
        );
    };

    // ================= PAGE =================
    return (
        <ApplicationLayout>
            <Helmet>
                <title>Notification Type Listing</title>
            </Helmet>

            <div className="page_title row m0">
                <div className="col-12">
                    <h3>Notification Type Listing</h3>

                    <div className="text-end mt15">
                        <Link to="/notification_type_add">
                            <button className="btn btn-primary">
                                Add
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className="pageTbl col-12">
                        {notificationListingJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default NotificationType;